import { useLoginStore } from '@/stores'
import service from '@/services'
import { MTP2WebSocket } from './build'
import { Package50 } from './package'
import { pushMessage50 } from './message'

export default new (class {
    private loginStore = useLoginStore()

    /** 交易链路 */
    private socket = new MTP2WebSocket(Package50);

    constructor() {
        this.socket.onPush = (pkg) => pushMessage50(pkg, 'unencrypted')
    }

    async connect() {
        const res = await service.onReady()
        await this.socket.connect(res.tradeWS, this.loginStore.token)
    }

    /**
     * 关闭交易链路
     */
    close() {
        this.socket?.close()
    }
})